export interface IBrowserInformation {
  browserLanguage?: string;
  browserUserAgent?: string;
  challengeWindowSize?: string;
  browserColorDepth?: string;
	browserScreenHeight?: number;
  browserScreenWidth?: number;
  browserTZ?: number;
  browserJavaEnabled?: boolean;
}

export class BrowserInformation implements IBrowserInformation {
  constructor(
    browserLanguage?: string,
    challengeWindowSize?: string,
    browserUserAgent?: string
  ) {}
}
